import React from 'react';
import { useLocation } from 'react-router-dom';
import StaticShell from '../Static/StaticShell';
import { regionFromPathname } from '../../utils/regionFromPath';
import { useI18n } from '../../hooks/useI18n';
import SEO from '../../components/seo/SEO';
import ManagedInlineBanner from '../../components/ads/ManagedInlineBanner';
import { bannerAds } from '../../data/staticAds';

export default function AboutPage() {
  const region = regionFromPathname(useLocation().pathname);
  const { t } = useI18n();
  return (
    <>
      <SEO
        region={region}
        path="/about"
        title={t('static.about.title', 'About FliqMatch')}
        description={t('static.about.p1', 'FliqMatch helps you find similar titles.')}
      />
      <StaticShell title={t('static.about.title', 'About FliqMatch')} region={region}>
        <>
          <p>{t('static.about.p1', 'FliqMatch helps you find similar movies, TV shows, and anime.')}</p>
          <p>{t('static.about.p2', 'Curated picks and community voting make discovery easier.')}</p>
          <div style={{ marginTop: '2rem' }}>
            <ManagedInlineBanner pageKey="about" fallbackAd={bannerAds[0]} variant="inline" />
          </div>
        </>
      </StaticShell>
    </>
  );
}
